import React from "react";

export default function DashboardPage({ userName = "User" }) {
  const handleLogout = () => {
    alert("Logged out!");
  };

  return (
    <div style={stylesDashboard.page}>
      <header style={stylesDashboard.header}>
        <h1 style={stylesDashboard.welcome}>
          Welcome back, <span style={stylesDashboard.userName}>{userName}</span>!
        </h1>
        <button style={stylesDashboard.logoutButton} onClick={handleLogout}>
          Logout
        </button>
      </header>

      <section style={stylesDashboard.statsSection}>
        <h2 style={stylesDashboard.sectionTitle}>Your Dashboard</h2>
        <div style={stylesDashboard.cardsGrid}>
          <DashboardCard title="Orders" value="12" icon="📦" />
          <DashboardCard title="Pending Shipments" value="4" icon="🚚" />
          <DashboardCard title="Messages" value="3" icon="✉️" />
          <DashboardCard title="Account Balance" value="$520.00" icon="💰" />
        </div>
      </section>
    </div>
  );
}

function DashboardCard({ title, value, icon }) {
  return (
    <div style={stylesDashboard.card} tabIndex={0}>
      <div style={stylesDashboard.cardIcon}>{icon}</div>
      <h3 style={stylesDashboard.cardTitle}>{title}</h3>
      <p style={stylesDashboard.cardValue}>{value}</p>
    </div>
  );
}

const stylesDashboard = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#121212",
    color: "#eee",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "2rem 3rem",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2rem",
    borderBottom: "1px solid #333",
    paddingBottom: "1rem",
    flexWrap: "wrap",
    gap: "1rem",
  },
  welcome: {
    fontSize: "1.8rem",
    fontWeight: "600",
  },
  userName: {
    color: "#f5a623",
  },
  logoutButton: {
    backgroundColor: "#f5a623",
    border: "none",
    borderRadius: "8px",
    color: "#121212",
    fontWeight: "700",
    padding: "0.6rem 1.5rem",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "background-color 0.3s, transform 0.2s",
    boxShadow: "0 4px 6px rgba(245, 166, 35, 0.5)",
  },
  statsSection: {
    maxWidth: "960px",
    margin: "0 auto",
  },
  sectionTitle: {
    fontSize: "2.4rem",
    color: "#f5a623",
    marginBottom: "2rem",
    textAlign: "center",
    fontWeight: "700",
    letterSpacing: "1px",
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "2rem",
  },
  card: {
    backgroundColor: "#222",
    borderRadius: "14px",
    padding: "2rem 1.5rem",
    boxShadow: "0 8px 20px rgba(245,166,35,0.6)",
    textAlign: "center",
    color: "#eee",
    cursor: "default",
    outline: "none",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  cardIcon: {
    fontSize: "2.8rem",
    marginBottom: "0.8rem",
    userSelect: "none",
  },
  cardTitle: {
    fontSize: "1.3rem",
    marginBottom: "0.6rem",
    fontWeight: "700",
    color: "#f5a623",
  },
  cardValue: {
    fontSize: "2.2rem",
    fontWeight: "800",
  },
};
